import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import risk_head_bg from '../../static/images_ae/reporting/risk_head_bg.png';
import risk_area from '../../static/images_ae/reporting/risk_area.png';
import risk_organ from '../../static/images_ae/reporting/risk_organ.png';
import risk_sympton from '../../static/images_ae/reporting/risk_sympton.png';
import risk_organ_purple from '../../static/images_ae/alkReport/risk_organ_purple.png';
import risk_sympton_purple from '../../static/images_ae/alkReport/risk_sympton_purple.png';
import risk_head_purple_bg from '../../static/images_ae/alkReport/risk_head_purple_bg.png';
import risk_level_0 from '../../static/images_ae/alkReport/risk_level_0.png';
import risk_level_1 from '../../static/images_ae/alkReport/risk_level_1.png';
import risk_level_2 from '../../static/images_ae/alkReport/risk_level_2.png';
import risk_level_3 from '../../static/images_ae/alkReport/risk_level_3.png';
import risk_level_4 from '../../static/images_ae/alkReport/risk_level_4.png';
import risk_level_no from '../../static/images_ae/alkReport/risk_level_no.png';
import NumToCn from '../../utils/numToCn.js';
import { withRouter } from 'react-router-dom';
import styles from './detail.module.scss';
import utils from '../../utils/utils';

const api = new ApiCore();

const Chest = (props: any) => {

    const [reportData, setReportData] = useState<any>({});

    useEffect(() => {
        window.document.title = 'ALK肺癌慢病管理风险评估报告';
        initData();
        return () => {
            // window.removeEventListener('popstate', onPopState);
        }
    }, [])

    const initData = () => {
        const _urlParams = utils.getUrlParams();
        const reportCode = _urlParams.reportCode || '';
        api.getEvaluationDetail(reportCode).then((res: any) => {
            if (res.code == 0) {
                setReportData(res.data || {});
            }
        });
    }

    return (
        <div className={styles.ae_reporting}>
            <div className={styles.risk_head}>
                <img className={styles.risk_head_bg} src={risk_head_purple_bg} alt="" />
                <div className={styles.risk_content}>
                    <div className={styles.risk_title}>ALK肺癌慢病管理风险评估报告</div>
                    <div className={styles.risk_time}>报告时间：{reportData.createTime ? reportData.createTime.replace('T', ' ') : ''}</div>
                </div>
            </div>
            <div className={styles.risk_level_content}>
                    <div className={styles.risk_level_head}>您的ALK风险等级疑似为</div>
                    <div className={styles.risk_level_body}>
                        {/* <div className={styles.risk_level_body_circle}>暂无</div> */}
                        {
                            reportData.risklevel !== undefined &&
                            <img src={
                                reportData.risklevel == 0 ? 
                                risk_level_0 : reportData.risklevel == 1 ? 
                                risk_level_1 : reportData.risklevel == 2 ?
                                risk_level_2 : reportData.risklevel == 3 ?
                                risk_level_3 : reportData.risklevel == 4 ?
                                risk_level_4 : risk_level_no
                                } 
                            alt="" />
                        }
                    </div>
            </div>
            <div className={styles.risk_treatment_content}>
                <div className={styles.treatment_top}>
                    <div className={styles.treatment_top_border}></div>
                    <div className={styles.treatment_top_border_text}>病情调研</div>
                </div>
                <div className={styles.treatment_gap}></div>
                <div className={styles.treatment_bottom}>
                    <div className={`${styles.investigation_title} ${styles.investigation_title_top0}`}>1、您的年龄（岁）：</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.age}</div>
                    <div className={styles.investigation_title}>2.	您的性别：</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.sex}</div>
                    <div className={styles.investigation_title}>3.	您现在所患的肺癌病理类型是？</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.cancerType}</div>
                    <div className={styles.investigation_title}>4.	您现在基因靶点检测为阳性结果的是？</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.detectionType}</div>
                    <div className={styles.investigation_title}>5.	您目前的治疗阶段是？</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.treatmentStage}</div>
                    <div className={styles.investigation_title}>6.	您目前的治疗方案是？（可多选）</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.treatments }</div>
                    <div className={styles.investigation_title}>7.	您在进行癌症全身治疗之前是否合并患有其他疾病?（可多选）</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.diseases}</div>
                    <div className={styles.investigation_title}>8.	您目前一般状态（PS）评分：</div>
                    <div className={styles.investigation_desc}>{reportData.investigation?.ps}</div>
                </div>
            </div>
            <div className={styles.risk_sympton_content}>
                <div className={styles.treatment_top}>
                    <div className={styles.treatment_top_border}></div>
                    <div className={styles.treatment_top_border_text}>ALK风险评估症状</div>
                </div>
                <div className={styles.treatment_gap}></div>
                {
                    reportData && (reportData.records || []).map((val: any, key: number) => (
                        <div key={key}>
                            {/* {
                                val.symptoms.map((v: any, index: number) => (
                                    <div key={index}> */}
                                        <div className={styles.sympton_top}>器官部位{(new NumToCn(key + 1 + '')).pri_ary()}</div>
                                        {/* <div className={styles.sympton_bottom}>
                                            <div className={styles.sympton_way}>
                                                <img className={styles.risk_area} src={risk_area} alt="" />
                                                <span>部位</span>
                                            </div>
                                            <div className={styles.sympton_solution}>
                                                {val.positionName}
                                            </div>
                                        </div> */}
                                        <div className={styles.sympton_bottom}>
                                            <div className={styles.sympton_way}>
                                                <img className={styles.risk_organ}  src={risk_organ_purple} alt="" />
                                                <span>器官</span>
                                            </div>
                                            <div className={styles.sympton_solution}>
                                                {val.organName}
                                            </div>
                                        </div>
                                        <div className={styles.sympton_bottom}>
                                            <div className={styles.sympton_way}>
                                                <img className={styles.risk_sympton}  src={risk_sympton_purple} alt="" />
                                                <span>症状</span>
                                            </div>
                                            <div className={styles.sympton_solution}>
                                                {val.symptoms.map((v: any) => (v.symptomName + ((v.riskLevel !== null && v.riskLevel >= 0) ? v.riskLevel + '级' : ''))).join('；')}
                                            </div>
                                        </div>
                                    {/* </div>
                                ))
                            } */}
                        </div>
                    ))
                }
                {/* <div className={styles.sympton_top}>症状一</div>
                <div className={styles.sympton_bottom}>
                    <div className={styles.sympton_way}>
                        <img className={styles.risk_area} src={risk_area} alt="" />
                        <span>部位</span>
                    </div>
                    <div className={styles.sympton_solution}>
                        <div>免疫治疗</div>
                    </div>
                </div>
                <div className={styles.sympton_bottom}>
                    <div className={styles.sympton_way}>
                        <img className={styles.risk_organ}  src={risk_organ} alt="" />
                        <span>器官</span>
                    </div>
                    <div className={styles.sympton_solution}>免疫治疗</div>
                </div>
                <div className={styles.sympton_bottom}>
                    <div className={styles.sympton_way}>
                        <img className={styles.risk_sympton}  src={risk_sympton} alt="" />
                        <span>症状</span>
                    </div>
                    <div className={styles.sympton_solution}>免疫治疗</div>
                </div> */}
                
            </div>
            {/* <div className={styles.risk_treatment_content}>
                <div className={styles.treatment_top}>
                    <div className={styles.treatment_top_border}></div>
                    <div className={styles.treatment_top_border_text}>治疗方式</div>
                </div>
                <div className={styles.treatment_gap}></div>
                <div className={styles.treatment_bottom}>
                    <div className={styles.treatment_way}>治疗方式</div>
                    <div className={styles.treatment_solution}>{reportData.treatments}</div>
                </div>
            </div> */}
            <div className={styles.risk_desc_content}>
                <div className={styles.risk_desc}>
                    <div className={styles.desc_title}>评测说明：</div>
                    <div>
                        本程序给出的ALK风险等级评测结果仅供参考，不
                        构成任何诊断和用药意见。您在ALK治疗过程中出
                        现任何症状，应当及时就医并遵从医生的诊断意见。
                    </div>
                    <div>
                        <div className={styles.each_level_title}>分级说明：</div>
                        <div className={styles.each_level}>1级：无症状</div>
                        <div className={styles.each_level}>2级：有症状，工具性活动受限</div>
                        <div className={styles.each_level}>3级：症状严重，自理活动受限</div>
                        <div className={styles.each_level}>4级：症状严重，危及生命</div>
                    </div>
                </div>
                <div className={styles.more_report_text_more}>
                <div className={styles.title}>
                    <div>评测参考文献：</div>
                    {/* <div onClick={(e) => { setShowDialogEvaluate(true) }}> 
                        <img src={tip_warning_filled} alt="" /> 
                        <span>查看评测说明</span> 
                    </div> */}
                </div>
                <div className={styles.text}>
                    <div>
                        {`[1]周清, 陆舜, 李勇, 贾福军, 李冠军, & 洪震等. (2022). 洛拉替尼特殊不良反应管理中国专家共识. 中国肺癌杂志,25(8), 12.`}
                    </div>
                    <div>
                        {`[2]常⻅不良事件评价标准(CTCAE) 5.0版（2017）`}
                    </div>
                    <div>
                        {`[3]王可, 李娟, 孙建国, 李力, 张西, & 张建勇等. (2021). 间变性淋巴瘤激酶抑制s剂不良反应管理西南专家建议(2021年版). 中国肺癌杂志, 24(12), 14.`}
                    </div>
                    <div>
                        {`[4]肺癌常用化疗药物说明书（培美曲塞、吉西他滨、紫杉醇、多西他赛、顺铂、长春瑞滨等）`}
                    </div>
                </div>
                </div>
            </div>

        </div>
    )
}

export default withRouter(Chest);